// import { Divider, Paper, Stack, Typography } from "@mui/material";
// import type React from "react";
// import SubpageWrapper from "../../lib/components/atomics/SubpageWrapper";
// import { getBorderRadius } from "../../lib/helpers/utils";

// interface InfoPageData {
// 	title: string;
// 	subtitle?: string;
// 	body: string;
// }

// const InfoBlock: React.FC<InfoPageData> = ({ title, subtitle, body }) => {
// 	return (
// 		<Paper
// 			sx={{
// 				px: { xs: 2, md: 6 },
// 				py: 3,
// 				width: "100%",
// 				borderRadius: getBorderRadius,
// 			}}
// 		>
// 			<Stack gap={1}>
// 				<Typography variant="h3">{title}</Typography>
// 				<Typography variant="subtitle1">{subtitle}</Typography>
// 				<Divider sx={{ my: 1 }} />
// 				<Typography variant="body1">{body}</Typography>
// 			</Stack>
// 		</Paper>
// 	);
// };
export const Info = () => {
	return null;
	//TODO: Fetch data
	// const dataFromDB = [
	// 	{
	// 		title: "Viktig informasjon om gasspris",
	// 		subtitle: "Prisutvikling Propan",
	// 		body: "Lorem ipsum lorem ipsum\nloren ipsum",
	// 	},
	// ] as InfoPageData[];
	// const pagetitle = "Viktig informasjon"; // Unsure if this is supposed to be a dynamic or static variable;

	// return (
	// 	<SubpageWrapper title={pagetitle} backRef={PATH_HOME}>
	// 		{dataFromDB.map((item, index) => (
	// 			<InfoBlock key={index} {...item} />
	// 		))}
	// 	</SubpageWrapper>
	// );
};

export default Info;
